import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from 'react';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import FeedbackIcon from '@helsenorge/designsystem-react/components/Icons/Feedback';
import Title from '@helsenorge/designsystem-react/components/Title';
import { IconSize } from '@helsenorge/designsystem-react';
import Close from './close';
import styles from './styles.module.scss';
const FeedbackModal = props => {
    const dialogRef = useRef(null);
    const titleId = useId();
    useEffect(() => {
        const timer = setTimeout(() => {
            dialogRef.current?.show();
        });
        return () => clearTimeout(timer);
    }, []);
    const handleKeyDown = (e) => {
        if (e.key === 'Escape' && dialogRef.current) {
            dialogRef.current.close();
        }
    };
    return (_jsxs("dialog", { ref: dialogRef, onClose: e => props.onClose(e.currentTarget.returnValue), "aria-labelledby": titleId, className: styles.feedbackmodal, onKeyDown: handleKeyDown, children: [_jsxs("div", { className: styles.feedbackmodal__header, children: [_jsx(Icon, { svgIcon: FeedbackIcon, size: IconSize.Small }), _jsx(Title, { appearance: "title4", htmlMarkup: "h2", id: titleId, className: styles.feedbackmodal__title, children: props.title })] }), _jsxs("form", { method: "dialog", className: styles.feedbackmodal__form, children: [_jsx(Close, { ariaLabel: props.closeButtonText, color: "plum", value: "close", type: "submit", className: styles.feedbackmodal__close }), props.children, _jsx("div", { className: styles.feedbackmodal__actions, children: props.buttons })] })] }));
};
export default FeedbackModal;
